import { Component } from "@angular/core";

@Component({
  selector: "app-layout-with-out-header",
  templateUrl: "./layoutWithOutHeader.component.html",
  styleUrls: ["./layoutWithOutHeader.component.css"],
})
export class LayoutWithOutHeaderComponent {
  constructor() {}
}